import { useEffect, useRef } from 'react';
import { PaginationState, SortingState } from '@tanstack/react-table';
import { TableOptions } from '@/types/table';

interface UseLazyLoadingParams<T> {
  lazyConfig: TableOptions<T>['lazy'];
  pagination: PaginationState;
  sorting: SortingState;
}

export const useLazyLoading = <T>({ lazyConfig, pagination, sorting }: UseLazyLoadingParams<T>) => {
  const hasLazyLoading = typeof lazyConfig?.loadPage === 'function';
  const loadPageRef = useRef(lazyConfig?.loadPage);

  useEffect(() => {
    loadPageRef.current = lazyConfig?.loadPage;
  }, [lazyConfig?.loadPage]);

  useEffect(() => {
    if (!hasLazyLoading) {
      return;
    }

    const currentSorting = sorting ?? [];
    const primarySort =
      currentSorting.length > 0 ? { field: currentSorting[0].id, desc: currentSorting[0].desc } : undefined;

    loadPageRef.current?.(
      { limit: pagination.pageSize, offset: pagination.pageIndex * pagination.pageSize },
      primarySort,
      currentSorting,
    );
  }, [hasLazyLoading, pagination.pageIndex, pagination.pageSize, sorting]);

  return { hasLazyLoading };
};
